import {useEffect, useState} from "react";
import {Repositories} from "../repositories/Repositories";
import {AccessPoint} from "../repositories/accesspoint/AccessPoint";

const useAccessPointListenerHook = (): AccessPoint[] => {
    const [accessPoints, setAccessPoints] = useState<AccessPoint[]>([]);

    useEffect(() => {
        fetchAccessPoints();
    }, []);

    const fetchAccessPoints = (): void => {
        Repositories.accessPoint.fetchAccessPoints()
            .then((accessPoints) => setAccessPoints(accessPoints));
    };

    return accessPoints;
};

export default useAccessPointListenerHook;
